import { Injectable } from '@angular/core';

import { Injector } from '@angular/core';
import { Observable, interval, of } from 'rxjs';
import { HttpService, autoSubscribe } from 'projects/core/src/public-api';
import { Vendor } from './vendor';
import { Material } from './material';
import {ShortObject} from '../../../../../../app-misc/src/app/modules/project-misc/data/project/short-json-object';


@Injectable({
    providedIn: 'root',
})
export class VendorsService extends HttpService {

    constructor(
        protected injector: Injector) {
        super(injector);
    }

    getVendors(): Observable<Vendor[]> {
        return this.getData(`/cv/vendors`, Vendor);
    }

    getVendor(vendorId: number): Observable<Vendor> {
        return this.getData(`/cv/vendors/${vendorId}`, Vendor);
    }

    getVendorsForMaterials(): Observable<ShortObject[]> {
        return this.getData(`/cv/vendors`, ShortObject);
    }

    getMaterials(vendorId: number): Observable<Material[]> {
        return this.getData(`/cv/vendors/${vendorId}/materials`, Material);
    }

    saveVendor(vendor: Vendor): Observable<Vendor> {
        return this.postData(`/cv/vendors/single-update`, vendor, Vendor)
    }

}